export const studioQueryKeys = {
  STUDIO_ITEM_DETAIL: ['STUDIO_ITEM_DETAIL'] as const,
  STUDIO_ITEM_LIST: ['STUDIO_ITEM_LIST'] as const,
};
